import React, { useEffect, useState } from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Grid,
  Toolbar,
  InputAdornment,
} from "@material-ui/core";
import { IoMdAdd } from "react-icons/io";
import { AiOutlineSearch } from "react-icons/ai";
import ConfirmDialog from "../../components/customHelpers/ConfirmDialog";
import Controls from "../../components/controls/Controls";
import Norecords from "../../components/customHelpers/Norecords";
import Loading from "../../components/customHelpers/Loading";
import useTable from "../../components/customHelpers/useTable";
import Notify from "../../components/customHelpers/Notify";
import Notification from "../../components/customHelpers/Notification";
import { FiEye } from "react-icons/fi";

import Layout from "../../components/layout/Layout";
import Admin from "../../components/auth/Admin";
import Staff from "../../actions/staff";
import AddStaffForm from "../../components/forms/addAdminStaff";
import Popup from "../../components/customHelpers/Popup";
import ChangePassword from "../../components/forms/updatePassword";
import ActivityLog from "../../components/activityLog";
import { MdModeEdit } from "react-icons/md";
import { Paper } from "@mui/material";
import { MdAssignmentInd } from "react-icons/md";
import Assignstaff from "./assignStaff";
import { MdOutlineDelete } from "react-icons/md";
import { useHistory } from "react-router-dom";

import produce from "immer";
const headCells = [
  { id: "fullName", label: "Full Name", hideOnMobile: false },
  { id: "email", label: "Email", hideOnMobile: false },
  { id: "phoneNo", label: "Phone Number", hideOnMobile: true },
  { id: "username", label: "UserName", hideOnMobile: true },
  {
    id: "actions",
    label: "Actions",
    disableSorting: true,
    hideOnMobile: false,
  },
];

const AdminStaffPage = () => {
  const history = useHistory();
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewAllAdminStaff, deleteAdminStaff } = Staff();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [staffId, setStaffId] = useState(null);

  const [openPopup, setOpenPopup] = useState(false);
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [openActivity, setOpenActivity] = useState(false);

  const [edite, setEdit] = useState(false);
  const [staff, setStaffs] = useState([]);
  const [openPopupAssign, setOpenPopupAssign] = useState(false);

  const [edit] = useState(false);
  const [id, setId] = useState(null);
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;

  useEffect(() => {
    getAllStaffs();
  }, [reload]);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const getAllStaffs = () => {
    setValues({ ...values, loading: true });
    viewAllAdminStaff().then((data) => {
      if (data.err || data.message) {
        NotifyMessage({
          message: data.err || data.message,
          type: "error",
        });
        setValues({
          ...values,
          loading: false,
        });
      } else if (data.staffs) {
        setValues({
          ...values,
          loading: false,
        });
        setStaffs(data.staffs);
      }
    });
  };
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(staff, headCells, filterFn);

  const handleSearch = (e) => {
    e.target.value = e.target.value.trimLeft();
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        const columns = ["fullName", "email", "username"];

        if (target.value === "") return items;
        else {
          return items.filter((x) => {
            return columns.some((column) => {
              return (
                x[column]
                  .toString()
                  .toLowerCase()
                  .indexOf(target.value.toLowerCase()) > -1
              );
            });
          });
        }
      },
    });
  };
  const onDelete = (Id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    deleteAdminStaff(Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.message) {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setValues({ ...values, reload: !reload });
        setStaffs(
          produce(staff, (draft) => {
            const index = staff.findIndex((item) => item.id === Id);
            if (index !== -1) draft.splice(index, 1);
          })
        );
      }
    });
  };
  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            Staffs
          </Typography>
          <Toolbar>
            <Controls.Input
              label="Search Staff"
              className="searchInput"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AiOutlineSearch />
                  </InputAdornment>
                ),
              }}
              onChange={handleSearch}
            />

            <Controls.Button
              text="Add Admin"
              variant="outlined"
              startIcon={<IoMdAdd />}
              className="newButton"
              onClick={() => {
                setOpenPopup(true);
                setRecordForEdit(null);
                setEdit(false);
              }}
            />
          </Toolbar>

          <Grid container>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {recordsAfterPagingAndSorting().length > 0 ? (
                        recordsAfterPagingAndSorting().map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>{item.fullName}</TableCell>
                            <TableCell>{item.email}</TableCell>
                            <TableCell>{item.phoneNo}</TableCell>
                            <TableCell>{item.username}</TableCell>
                            <TableCell>
                              <Controls.ActionButton
                                color="secondary"
                                title="Delete"
                                onClick={() => {
                                  setConfirmDialog({
                                    isOpen: true,
                                    title: item.staffOrganizations?.length > 0
                                      ? `Are you sure you want to remove this staff? It has ${item.staffOrganizations?.length} organization`
                                      : "Are you sure you want to remove this staff?",
                                    subTitle: "You can't undo this operation",
                                    onConfirm: () => {
                                      onDelete(item.id);
                                    },
                                  });
                                }}
                              >
                                <MdOutlineDelete fontSize="medium" />
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="primary"
                                title="Change Password"
                                onClick={() => {
                                  setOpenChangePassword(true);
                                  setStaffId(item.id);
                                }}
                              >
                                <MdModeEdit fontSize="medium" />
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="primary"
                                title="View Detail"
                                onClick={() => {
                                  history.push(
                                    `/admin/admin-organization/${item.id}`
                                  );
                                }}
                              >
                                <FiEye fontSize="medium" />
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="primary"
                                title="Assign"
                                onClick={() => {
                                  setOpenPopupAssign(true);
                                  setId(item.id);
                                }}
                              >
                                <MdAssignmentInd fontSize="medium" />
                              </Controls.ActionButton>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={6} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <TblPagination />
                </Paper>
              )}
            </Grid>
          </Grid>

          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <Notification notify={notify} setNotify={setNotify} />
        </div>
        <Popup
          title="Staff Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <AddStaffForm
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopup}
            recordForEdit={recordForEdit}
            setStaffs={setStaffs}
            getAllStaffs={getAllStaffs}
            edite={edite}
            role="admin"
          />
        </Popup>
        <Popup
          title="Change Password"
          openPopup={openChangePassword}
          setOpenPopup={setOpenChangePassword}
        >
          <ChangePassword
            superadmin="true"
            id={staffId}
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenChangePassword}
          />
        </Popup>
        <Popup
          title="Activity Log"
          openPopup={openActivity}
          setOpenPopup={setOpenActivity}
        >
          <ActivityLog
            id={staffId}
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenActivity}
          />
        </Popup>
        <Popup
          title="Change Password"
          openPopup={openChangePassword}
          setOpenPopup={setOpenChangePassword}
        >
          <ChangePassword
            superadmin="true"
            id={staffId}
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenChangePassword}
          />
        </Popup>
        <Popup
          title="Assign Organization"
          openPopup={openPopupAssign}
          setOpenPopup={setOpenPopupAssign}
        >
          <Assignstaff
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopupAssign}
            recordForEdit={recordForEdit}
            id={id}
          />
        </Popup>
      </Admin>
    </Layout>
  );
};

export default AdminStaffPage;
